export const initFilters = () => {
  document.querySelectorAll('.activeFilter').forEach((filter) => {
    filter.addEventListener('click', () => {
      const filterId = filter.getAttribute('data-filter-id');
      const checkbox = document.getElementById(filterId);
      if (checkbox) {
        checkbox.checked = false;
      }
    });
  });

  document.querySelectorAll('.activePriceFilter').forEach((filter) => {
    filter.addEventListener('click', () => {
      document.getElementById('minPrice').value = '';
      document.getElementById('maxPrice').value = '';
    });
  });

  document.querySelectorAll('.filter-option input').forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const form = checkbox.closest('form');
      if (form) {
        form.submit();
      }
    });
  });
};
